// Generated by CoffeeScript 2.7.0
var EsignatureAssignmentSetting;

import SignaturePadMixin from 'trunks/vue/share/mixins/signature_pad.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default EsignatureAssignmentSetting = {
  mixins: [SignaturePadMixin],
  template: `<div class="form-field required esignature-setting"
       :class="{ 'has-error': !valid }"
       v-if='true'>
    <div class="form-field-head">
      <div class="form-field-title">电子签字</div>
    </div>
    <div class="form-field-input-container">
      <div class="form-field-input">
        <div class="signature_pad">
          <div class="actions" dir='ltr'>
            <div class="btn icon-btn" @click='clear'>
              <i class="slp-clear"></i>
            </div>
          </div>
          <div class="signature_pad-canvas">
            <canvas ref='signature_pad'></canvas>
            <div class="signature_pad-tip">
              <div class="helper-text" v-if="showHelper">请在上方空白区域处签字</div>
            </div>
          </div>
        </div>
      </div>
      <div class="message" v-if='!valid'>电子签字不能为空</div>
    </div>
  </div>
</div>`,
  methods: {
    displaySignatureEmptyError: function() {
      return newAlertify('提交失败', {
        type: 'error',
        description: '请进行电子签字'
      });
    },
    getData: function() {
      return this.getSignature();
    }
  }
};
